const projectsNormalizerMixin = {
  methods: {
    projectsNormalizer (node) {
      return {
        id: parseInt(node.id),
        label: node.name,
        children: node.children
      }
    }
  }
}

export default projectsNormalizerMixin